import l from"styled-components";import{theme as t}from"../../../theme.js";const a=o=>{switch(o){case"small":return"8px 16px";case"medium":return"12px 24px";default:return"12px 24px"}},e=o=>{switch(o){case"small":return"12px";case"medium":return"14px";default:return"14px"}},i=o=>{switch(o){case"small":return"20px";case"medium":return"24px";default:return"24px"}},c=o=>{switch(o){case"small":return`
        width: 12px;
        height: 12px;
      `;case"medium":return`
        width: 18px;
        height: 18px;
      `;default:return`
        width: 18px;
        height: 18px;
      `}},F=()=>`
    background-color: #2A71D4;
    color: #FFFFFF;
    > svg path, g {
      fill: #FFFFFF; 
    }
    &:hover {
      background-color: #1B4887;
    }
    &:active {
      background-color: #E2E8F0;
      color: #47556E;
      > svg path, g {
        fill: #47556E; 
      }
    }
    &:disabled {
      background-color: #A1BDE5;
      color: #FFFFFF;
    }
  `,n=()=>`
    background-color: #A1BDE5;
    > svg path, g {
      fill: #FFFFFF; 
    }
  `,g=()=>`
    background-color: #062B54;
    color: #FFFFFF;
    > svg path, g {
      fill: #FFFFFF; 
    }
    &:hover {
      background-color: #1B4887;
    }
    &:active {
      background-color: #E2E8F0;
      color: #47556E;
      > svg path, g {
        fill: #47556E; 
      }
    }
    &:disabled {
      background-color: #A1BDE5;
      color: #FFFFFF;
    }
  `,s=()=>`
    background-color: #A1BDE5;
    > svg path, g {
      fill: #FFFFFF; 
    }
  `,d=()=>`
    background-color: #E2E8F0;
    color: #47556E;
    > svg path, g {
      fill: #47556E; 
    }
    &:hover, &:active {
      background-color: #CBD5E1;
      color: #47556E;
    }
    &:disabled {
      background-color: #E2E8F0;
      color: #94A3B8;
      > svg path, g {
        fill: #94A3B8; 
      }
    }
  `,u=()=>`
    background-color: #E2E8F0;
    > svg path, g {
      fill: #FFFFFF; 
    }
  `,p=()=>`
    color: #2A71D4;
    background-color: unset;
    > svg path, g {
      fill: #2A71D4; 
    }
    &:hover, &:active {
      background-color: #F8FAFD;
    }
    &:disabled {
      background-color: unset;
      color: #CBD5E1;
      > svg path, g {
        fill: #CBD5E1; 
      }
    }
  `,h=()=>`
    color: #FFFFFF;
    background-color: unset;
    > svg path, g {
      fill: #FFFFFF; 
    }
    &:hover, &:active {
      background-color: #3F7FD8;
    }
    &:disabled {
      background-color: unset;
      color: #A1BDE5;
      > svg path, g {
        fill: #A1BDE5; 
      }
    }
  `,v=l.button`
  cursor: pointer;
  width: ${({fullWidth:o})=>o?"100%":"fit-content"};
  border-radius: ${t.radius}px;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  font-weight: 700;
  justify-content: center;
  padding: ${({size:o})=>a(o)};
  font-size: ${({size:o})=>e(o)};
  line-height: ${({size:o})=>i(o)};
  margin: 0;
  ${({variant:o,isLoading:r})=>o==="primary"&&(r?n():F())};
  ${({variant:o,isLoading:r})=>o==="secondary"&&(r?s():g())};
  ${({variant:o,isLoading:r})=>o==="tertiary"&&(r?u():d())};
  ${({variant:o})=>o==="text"&&p()};
  ${({variant:o})=>o==="textOnColor"&&h()};
  > svg {
    margin-right: ${t.spacing*2}px;
    ${({size:o})=>c(o)};
    &.spinner {
      margin: 0;
      width: 24px;
      height: 24px;
    }
  }
`;export{v as StyledButton};
